import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
// import React, { useEffect, useState } from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
// import { getWindowWidth } from '../../CustomHooks/isMobileViewHook';
import './pagination.css';
import classes from './Pagination.module.css';

export const PaginationComponent = ({ totalPages, currentPage, setCurrentPage, className }) => {
  // const [isMobile, setIsMobile] = useState(false);
  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  // useEffect(() => {
  //   getWindowWidth(setIsMobile, 520);
  // }, []);

  return (
    <div className={[classes.paginationDiv, `${className && className}`].join(' ')}>
      <style>{`
      .MuiPagination-ul li .Mui-selected{
        background-color: var(--secondary-clr);
        color: var(--white-clr) !important;
      }
      .MuiPagination-ul li:not(.Mui-selected) button:hover, 
      .MuiPagination-ul li:not(.Mui-selected) button:focus{
        background-color: var(--secondary-clr-hover) !important;
        color: var(--white-clr) !important;
      }
      
      `}</style>

      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handleChange}
        className={[classes.pageItem, 'ltr'].join(' ')}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            shape="rounded"
            sx={{
              '&.Mui-selected': {
                backgroundColor: 'var(--secondary-clr)',
                color: 'var(--white-clr)'
              },
              '&:hover': {
                backgroundColor: 'var(--secondary-clr-hover)',
                color: 'var(--white-clr)'
              }
            }}
            components={{
              previous: () => (
                <span className={classes.paginationText}>
                  <MdKeyboardArrowLeft /> Previous
                </span>
              ),
              next: () => (
                <span className={classes.paginationText}>
                  Next <MdKeyboardArrowRight />
                </span>
              )
            }}
          />
        )}
      />
    </div>
  );
};
